import { render } from "./TerminalDialog.vue?vue&type=template&id=4962c7aa"
import script from "./TerminalDialog.ts?vue&type=script&lang=js"
export * from "./TerminalDialog.ts?vue&type=script&lang=js"

import "./TerminalDialog.vue?vue&type=style&index=0&id=4962c7aa&lang=css"

import exportComponent from "/Users/r.hutter/Resilio Sync/_Workspace/git/TitleTool-NG/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__